import _ from "lodash";
import { useMemo } from "react";
import { getMobileMarketOrderParamsByCollectionKey } from "../../MobileMarket/mobileMarketUtils";
import Asset from "../../../../modules/Asset/Asset";
import { useSelector } from "react-redux";
import { getLiteTradeAssetsBySymbol } from "../../../../modules/LiteTrade/liteTradeSelectors";
import { useLiteTradeCollection } from "../../../../modules/LiteTrade/hooks/useLiteTradeCollection";

const useMobileWidgetCardsAssets = (collectionKey: string, assetsCount: number) => {
    const userAssetsMap = useSelector(getLiteTradeAssetsBySymbol);
    const { data: collectionData, title: collectionTitle, openCollectionSlide } = useLiteTradeCollection(collectionKey);

    const assets = useMemo(() => {
        const { fields: orderByFields, directions: orderByDirections } =
            getMobileMarketOrderParamsByCollectionKey(collectionKey);
        return _.chain(collectionData?.assets || [])
            .map(collectionAsset => {
                const asset = userAssetsMap[collectionAsset.symbol];
                const assetInstance = new Asset(asset);
                return ({
                    ...asset,
                    ...collectionAsset,
                    assetInstance,
                    emptyPosition: !collectionAsset.position,
                    inactive: !assetInstance.isTradingNow(),
                    lowerDescription: _.toLower(asset.info?.description),
                    position: collectionAsset.position,
                    updatedAt: collectionAsset.updated_at,
                })
            })
            .orderBy(orderByFields, orderByDirections)
            .take(assetsCount)
            .value();

    }, [assetsCount, collectionData, collectionKey, userAssetsMap]);

    return {
        assets,
        collectionTitle,
        openCollectionSlide,
    }
}

export default useMobileWidgetCardsAssets;
